// Home: case study — one podcast episode: its automatic timestamps, then two questions asked in its chat.
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faListUl, faComments } from '@fortawesome/free-solid-svg-icons';
import barkley_thumbnail from '../../assets/images/thumbnail/barkley-thumbnail.jpeg';

const TIMESTAMPS = [
  ['14:32', 'Meeting the team'],
  ['19:32', 'College football advice'],
  ['26:30', 'College camaraderie'],
  ['29:06', 'Records and legacies'],
  ['45:10', 'Rookie pranks'],
  ['47:19', 'First NFL touchdown'],
  ['53:59', 'New York success'],
  ['1:03:55', 'Running back market'],
];

const TAKEAWAYS = [
  ['🏈', 'Saquon Barkley’s Transition', 'Reflects on joining the Philadelphia Eagles, embracing a new role, and contributing to team success'],
  ['🏆', 'NFL and College Reflections', 'Discusses college football challenges, professional transitions, and the evolving landscape of the sport'],
  ['🏃‍♂️', 'Running Back Insights', 'Explores the running back market, player versatility, and the physical demands of professional football'],
];

const HASHTAGS = ['SaquonBarkley', 'PhiladelphiaEagles', 'NFL', 'Football', 'RunningBacks', 'NFLDraft'];

const DESCRIPTION = 'Join hosts Travis and Jason Kelce on New Heights as they welcome NFL star Saquon Barkley to discuss his transition to the Eagles, playing with Brandon Graham, and his excitement for the team’s potential.';

const Output = ({ icon, title, children, wide }) => (
  <div className={`home-output${wide ? ' home-output--wide' : ''}`}>
    <p className="home-output-title"><FontAwesomeIcon icon={icon} /> {title}</p>
    {children}
  </div>
);

// A message the user sent in the episode's chat; the answer follows it in the same card
const Ask = ({ children }) => <p className="home-ask">{children}</p>;

export default function PodcastShowcase() {
  return (
    <section className="mk-section">
      <div className="mk-container home-case">
        <div className="home-case-text">
          <p className="mk-eyebrow">Case study</p>
          <h2 className="mk-h2">Podcasters</h2>
          <p className="mk-lead">
            Podcasters are just one of the many users who love our platform. Bump AI chapters every episode
            automatically, then writes takeaways, show notes, and hashtags when you ask for them.
          </p>
          <Link to="/signup" className="mk-link">
            Try it on your episode <FontAwesomeIcon icon={faArrowRight} className="mk-btn-arrow" />
          </Link>
        </div>

        <div className="home-case-board mk-glow">
          <div className="home-case-video">
            <img src={barkley_thumbnail} alt="New Heights podcast episode with Saquon Barkley" loading="lazy" width="1280" height="720" />
          </div>
          <div className="home-outputs">
            <Output icon={faListUl} title="Timestamps">
              <ul className="home-timestamps">
                {TIMESTAMPS.map(([t, label]) => <li key={t}><span>{t}</span> {label}</li>)}
              </ul>
            </Output>
            <Output icon={faComments} title="Ask Bump AI">
              <Ask>What are the three big takeaways?</Ask>
              <ul className="home-takeaways">
                {TAKEAWAYS.map(([icon, head, text]) => (
                  <li key={head}><span aria-hidden="true">{icon}</span> <span><b>{head}:</b> {text}</span></li>
                ))}
              </ul>
            </Output>
            <Output icon={faComments} title="Follow-up" wide>
              <Ask>Turn that into an episode description with hashtags.</Ask>
              <p className="home-output-text">{DESCRIPTION}</p>
              <div className="home-hashtags">
                {HASHTAGS.map(tag => <span key={tag}>#{tag}</span>)}
              </div>
            </Output>
          </div>
        </div>
      </div>
    </section>
  );
}
